import {xml2json} from "xml-js";

export default function wechatMsgHandle (msg) {
    if (/<msg><voicemsg.*<\/msg>/g.test(msg))
        return '[语音消息]'
    // if (/\[pic=.*,isDecrypt=\d]$/g.test(msg))
    //     return '[图片]'
    // .xml2json(a, {compact: true, spaces: 4})
    return msg
}

export function wechatMsgEntityHandle (entity) {
    if (entity.msgType === 47) {
        let json = xml2json(entity.msg, {compact: true, spaces: 4})
        entity.msg = JSON.parse(json).msg.emoji._attributes.cdnurl
    } else
        entity.msg = wechatMsgHandle(entity.msg)
    entity.timeStamp = new Date(entity.timeStamp - 0).Format('yyyy-MM-dd HH:mm:ss')
    return entity
}

// const c = require("xml-js")
// let a = `<?xml version="1.0" encoding="utf-8"?><msg>
//     <appmsg appid="" sdkver="0">
//         <title><![CDATA[9元外卖大红包来喽~]]></title>
//         <des><![CDATA[点外卖前记得先来领券呦~]]></des>
//         <action></action>
//         <type>5</type>
//         <showtype>1</showtype>
//         <content><![CDATA[]]></content>
//         <contentattr>0</contentattr>
//         <url><![CDATA[http://mp.weixin.qq.com/s?__biz=Mzg5MDY3MTk4Ng==&mid=2247485460&idx=1&sn=75394240c1f63e5baf259c1d126854d6&chksm=cfd84e09f8afc71f5da65d7b9adee7caa2a9312b83e77548d716e1ff72216940ff425fe91806&scene=0&xtrack=1#rd]]></url>
//         <lowurl><![CDATA[]]></lowurl>
//         <appattach>
//             <totallen>0</totallen>
//             <attachid></attachid>
//             <fileext></fileext>
//         </appattach>
//         <extinfo></extinfo>
//         <mmreader>
//             <category type="20" count="1">
//                 <name><![CDATA[减减单]]></name>
//                 <topnew>
//                     <cover><![CDATA[https://mmbiz.qpic.cn/sz_mmbiz_jpg/h1aric9Y4ocsibdZeL2O0cH0K2V54iauDwhiatTYaVMicQMjNHWGM23eKibTMsWB0Syp6J1Y8LRAs6Ql3kdES0Krndsw/640?wxtype=jpeg&wxfrom=0]]></cover>
//                     <width>0</width>
//                     <height>0</height>
//                     <digest><![CDATA[点外卖前记得先来领券呦~]]></digest>
//                 </topnew>
//
//                 <item>
//                     <itemshowtype>0</itemshowtype>
//                     <title><![CDATA[9元外卖大红包来喽~]]></title>
//                     <url><![CDATA[http://mp.weixin.qq.com/s?__biz=Mzg5MDY3MTk4Ng==&mid=2247485460&idx=1&sn=75394240c1f63e5baf259c1d126854d6&chksm=cfd84e09f8afc71f5da65d7b9adee7caa2a9312b83e77548d716e1ff72216940ff425fe91806#rd]]></url>
//                     <shorturl><![CDATA[]]></shorturl>
//                     <longurl><![CDATA[]]></longurl>
//                     <pub_time>1686105540</pub_time>
//                     <summary><![CDATA[没关注？伸出手指点这里---忙碌了一上午疲惫的身心需要美食来治愈今天吃什么呢？不管吃啥，先领外卖券再点今日美团9元外卖大红包饿了么8元红包冲冲冲（仅限今日使用 今日领取）美团外卖9元大额红包全天可领，]]></summary>
//                     <cover><![CDATA[https://mmbiz.qpic.cn/sz_mmbiz_jpg/h1aric9Y4ocsibdZeL2O0cH0K2V54iauDwhiatTYaVMicQMjNHWGM23eKibTMsWB0Syp6J1Y8LRAs6Ql3kdES0Krndsw/640?wxtype=jpeg&wxfrom=0]]></cover>
//                     <tweetid></tweetid>
//                     <digest><![CDATA[点外卖前记得先来领券呦~]]></digest>
//                     <fileid>0</fileid>
//                     <sources>
//                         <source>
//                             <name><![CDATA[减减单]]></name>
//                         </source>
//                     </sources>
//                     <styles></styles>
//                     <native_url></native_url>
//                     <del_flag>0</del_flag>
//                     <contentattr>0</contentattr>
//                     <play_length>0</play_length>
//                     <play_url><![CDATA[]]></play_url>
//                     <voice_id><![CDATA[]]></voice_id>
// <player><![CDATA[]]></player>
//
//
//                     <music_source>0</music_source>
//                     <pic_num>0</pic_num>
//                     <vid></vid>
//                     <author><![CDATA[]]></author>
//                     <recommendation><![CDATA[]]></recommendation>
//                     <pic_urls></pic_urls>
//                     <comment_topic_id>0</comment_topic_id>
//                     <cover_235_1><![CDATA[https://mmbiz.qpic.cn/sz_mmbiz_jpg/h1aric9Y4ocsibdZeL2O0cH0K2V54iauDwhiatTYaVMicQMjNHWGM23eKibTMsWB0Syp6J1Y8LRAs6Ql3kdES0Krndsw/640?wxtype=jpeg&wxfrom=0]]></cover_235_1>
//                     <cover_1_1><![CDATA[https://mmbiz.qpic.cn/sz_mmbiz_jpg/h1aric9Y4ocsibdZeL2O0cH0K2V54iauDwhJ7fI4vekcRrzsdhZCdLcMUVdmLJjiaBm3RvHEzmvfkdm0clbiaVsLlMQ/300?wxtype=jpeg&wxfrom=0]]></cover_1_1>
//                     <cover_16_9><![CDATA[https://mmbiz.qpic.cn/sz_mmbiz_jpg/h1aric9Y4ocsibdZeL2O0cH0K2V54iauDwhiatTYaVMicQMjNHWGM23eKibTMsWB0Syp6J1Y8LRAs6Ql3kdES0Krndsw/640?wxtype=jpeg&wxfrom=0]]></cover_16_9>
//                     <appmsg_like_type>2</appmsg_like_type>
//                     <video_width>0</video_width>
//                     <video_height>0</video_height>
//                     <is_pay_subscribe>0</is_pay_subscribe>
// 			<finder_feed>
// 			    <object_id><![CDATA[]]></object_id>
// 			    <object_nonce_id><![CDATA[]]></object_nonce_id>
// 			    <feed_type>0</feed_type>
// 			    <nickname><![CDATA[]]></nickname>
// 			    <avatar><![CDATA[]]></avatar>
// 			    <desc><![CDATA[]]></desc>
// 			    <media_count>0</media_count>
// 			    <media_list>
//
// 			    </media_list>
// 			    <mega_video>
// 				<object_id><![CDATA[]]></object_id>
// 				<object_nonce_id><![CDATA[]]></object_nonce_id>
// 			    </mega_video>
// 			</finder_feed>
//                         <finder_live>
//                             <finder_username><![CDATA[]]></finder_username>
//                             <category><![CDATA[]]></category>
//                             <finder_nonce_id><![CDATA[]]></finder_nonce_id>
//                             <export_id><![CDATA[]]></export_id>
//                             <nickname><![CDATA[]]></nickname>
//                             <head_url><![CDATA[]]></head_url>
//                             <desc><![CDATA[]]></desc>
//                             <live_status></live_status>
//                             <live_source_type_str><![CDATA[]]></live_source_type_str>
//                             <ext_flag></ext_flag>
//                             <auth_icon_url><![CDATA[]]></auth_icon_url>
//                             <auth_icon_type_str><![CDATA[]]></auth_icon_type_str>
//                             <media>
//                                 <cover_url><![CDATA[]]></cover_url>
//                                 <height></height>
//                                 <width></width>
//                             </media>
//                         </finder_live>
//                 </item>
//
//             </category>
//             <publisher>
//                 <username><![CDATA[gh_b9ffeb4bb69f]]></username>
//                 <nickname><![CDATA[减减单]]></nickname>
//             </publisher>
//             <template_header></template_header>
//             <template_detail></template_detail>
//             <forbid_forward>0</forbid_forward>
//         </mmreader>
//         <thumburl><![CDATA[https://mmbiz.qpic.cn/sz_mmbiz_jpg/h1aric9Y4ocsibdZeL2O0cH0K2V54iauDwhiatTYaVMicQMjNHWGM23eKibTMsWB0Syp6J1Y8LRAs6Ql3kdES0Krndsw/640?wxtype=jpeg&wxfrom=0]]></thumburl>
//     </appmsg>
//     <fromusername><![CDATA[gh_b9ffeb4bb69f]]></fromusername>
//     <appinfo>
//         <version></version>
//         <appname><![CDATA[减减单]]></appname>
//         <isforceupdate>1</isforceupdate>
//     </appinfo>
//
//
//
//
//
//
// </msg>`
// var xml =
//     '<?xml version="1.0" encoding="utf-8"?>' +
//     '<note importance="high" logged="true">' +
//     '    <title>Happy</title>' +
//     '    <todo>Work</todo>' +
//     '    <todo>Play</todo>' +
//     '</note>';
// var result1 = c.xml2json(xml, {compact: true, spaces: 4});
// var result2 = c.xml2json(xml, {compact: false, spaces: 4});
// console.log(result1, '\n', result2);
// a = c.xml2json(a, {compact: true, spaces: 4})
// console.log(a)